import { BaseApiService } from '@/shared/api/services/base.service';

export interface AuthMethodsResponse {
  data: {
    type: string;
    id: string;
    attributes: {
      methods: string[];
      has_password: boolean;
      has_google: boolean;
      has_apple: boolean;
      google_email?: string;
      apple_email?: string;
    };
  };
}

export interface AuthMethodRequest {
  data: {
    type: string;
    attributes: {
      password?: string;
      password_confirmation?: string;
    };
  };
}

export class AuthMethodsService extends BaseApiService {
  /**
   * Get available authentication methods for the current user
   */
  async getAuthMethods(): Promise<AuthMethodsResponse> {
    return this.httpGet<AuthMethodsResponse>('/v1/auth/methods');
  }

  /**
   * Add password authentication method
   */
  async addPasswordMethod(
    password: string,
    passwordConfirmation: string
  ): Promise<AuthMethodsResponse> {
    const payload = {
      data: {
        type: 'auth-method',
        attributes: {
          password,
          password_confirmation: passwordConfirmation,
        },
      },
    };

    return this.post<AuthMethodsResponse>('/v1/auth/methods/password', payload);
  }

  /**
   * Remove an authentication method
   */
  async removeMethod(method: string): Promise<void> {
    return this.httpDelete<void>(`/v1/auth/methods/${method}`);
  }
}

export const authMethodsService = new AuthMethodsService();
